<template>
    <hr class="my-4 h-0.25 w-full bg-gray-200" />
</template>
